const settingsBlack = {
    backgroundColor : '#18191A',
    backgroundColor2 : '#18191A',
    cardBackgroundColor: '#242526',
    inputBackgroundColor: '#464647',
    card2BackgroundColor: '#575757',
    footerBackgroundColor: '#2F2F2F',
    card3BackgroundColor: '#464647',
    card4BackgroundColor : '#575757',
    footerWave : `url(/assets/img/vague_dark_mode.png)`,
    textColor : '#E7E7E7',
    textColor2 : '#E7E7E7',
    logoUrl : `/assets/icon/logo-ohs-white.png`,
    textColor3 : '#E7E7E7',
    textColor4 : '#E7E7E7',
    textColor5 : '#FFFFFF',
    textColor6 : '#DD809D',
    textColor7 : '#FFFFFF',
    textColor8 : '#FFFFFF',
    textColor9 : '#FFFFFF',
    textColor10 : '#FFFFFF',
    breadcrumbColor1 : '#E7E7E7',
    pinkBackgroundColor : '#464647',
    notifCardBackgroundCor : '#464647',
    color11: '#E7E7E7',
    color12: '#242526',
    color13: '#464647',
    color14: '#E7E7E7',
    color15: '#575757',
    textColor11 : '#3E9FDD',
    iconNotif: 'white',
}

export default settingsBlack;
